import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Navigate, useSearchParams } from "react-router-dom";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import AuthLogo from "../../Components/Auth/AuthLogo";
import AuthCard from "../../Components/Auth/AuthCard";
import AuthContainer from "../../Components/Auth/AuthContainer";
import PublicPageCard from "../../Components/Auth/PublicPageCard";
import Icon from "Components/Icons/Icon";
import { regeneratePaymentLink } from "slices/thunks";
import { useAppDispatch } from "Components/Hooks/hooks";
import { ErrorHandler } from "utils/toast";

const DepositPaySuccess = () => {
  document.title = "EaziQuote - Payment Successful";

  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("payment_id");
  const status = searchParams.get("status");
  const dispatch = useAppDispatch();
  const [isRetrying, setIsRetrying] = useState(false);

  if (
    !paymentId ||
    (status !== "success" &&
      status !== "error" &&
      status !== "cancelled" &&
      status !== "failed")
  ) {
    return <Navigate to="/" replace />;
  }

  const handleRetry = async () => {
    try {
      setIsRetrying(true);
      const response = await dispatch(
        regeneratePaymentLink({ id: Number(paymentId) }),
      ).unwrap();
      const url = response?.payload?.stripe_payment_link_url;
      if (url) {
        window.location.href = url;
      }
      setIsRetrying(false);
    } catch (error) {
      ErrorHandler(error);
      setIsRetrying(false);
    }
  };

  const isError =
    status === "error" || status === "failed" || status === "cancelled";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <AuthContainer>
          <Container>
            <Row>
              <Col lg={12}>
                <AuthLogo />
              </Col>
            </Row>

            <Row className="auth-container">
              <Col md={8} lg={6} xl={5}>
                <AuthCard>
                  <PublicPageCard
                    icon={
                      <Icon
                        name={isError ? "Error" : "SuccessTick"}
                        width={80}
                        height={80}
                      />
                    }
                    title={isError ? "Payment Failed" : "Payment Successful!"}
                    description={
                      isError
                        ? "Your payment could not be processed. Please try again or contact support if the issue persists."
                        : "Your payment has been completed successfully. Thank you for your transaction."
                    }
                    buttonText={isError ? "Retry Payment" : undefined}
                    onButtonClick={isError ? handleRetry : undefined}
                    buttonLoading={isRetrying}
                  />
                </AuthCard>
              </Col>
            </Row>
          </Container>
        </AuthContainer>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default DepositPaySuccess;
